/*
 * cart-gel-guard.js — el gel automatico de la Rutina no debe poder multiplicarse.
 *
 * Motivo: un usuario subio el stepper del carrito hasta 242 geles automaticos.
 * El gel es una suscripcion a $0 hoy que luego cobra $425 c/90 dias POR UNIDAD,
 * asi que multiplicarlo es un problema real de cobro, no cosmetico.
 *
 * Que hace:
 *  1) Oculta el contador (+/-) SOLO en la linea del gel automatico del drawer
 *     de Rebuy. La papelera se conserva: en la oferta general la Rutina es
 *     opcional, el cliente si debe poder quitarla.
 *  2) Respaldo en JS: si por cualquier via la cantidad del gel queda > 1
 *     (carritos viejos, API, UI stale), la regresa a 1.
 *
 * El unico camino para cambiar cantidades es el drawer de Rebuy: /cart redirige
 * al home. Aun asi el clamp cubre carritos ya "envenenados".
 *
 * Nota: Rebuy renderiza su propia plantilla (el snippet rebuy-cart-template.liquid
 * del theme esta MUERTO), pero al <li> si le pone la clase product-<handle>.
 * Si cambia el HANDLE del gel automatico, actualizar GEL_HANDLE y GEL_VARIANT.
 */
(function (global) {
  'use strict';

  var GEL_HANDLE = 'gel-hidratante-200g-auto';
  var GEL_VARIANT = 49093433852139;
  var MAX_QTY = 1;

  /**
   * Logica pura: dadas las lineas del carrito, que cambios hay que hacer.
   * @param {Array<{variant_id:number, quantity:number, key:string}>} items
   * @returns {Array<{key:string, quantity:number}>}
   */
  function planClamp(items, variantId, maxQty) {
    variantId = variantId || GEL_VARIANT;
    maxQty = maxQty || MAX_QTY;
    var out = [];
    (items || []).forEach(function (it) {
      if (it && it.variant_id === variantId && it.quantity > maxQty) {
        out.push({ key: it.key, quantity: maxQty });
      }
    });
    return out;
  }

  // ---- Node (tests) ----
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { planClamp: planClamp, GEL_HANDLE: GEL_HANDLE, GEL_VARIANT: GEL_VARIANT, MAX_QTY: MAX_QTY };
    return;
  }

  // ---- Navegador ----
  var doc = global.document;
  if (!doc) return;

  // 1) Esconder el contador en la linea del gel (la papelera se queda).
  function injectCss() {
    if (doc.getElementById('cart-gel-guard-css')) return;
    var css =
      '.rebuy-cart__flyout-item.product-' + GEL_HANDLE + ' .rebuy-cart__flyout-item-quantity{display:none!important;}';
    var st = doc.createElement('style');
    st.id = 'cart-gel-guard-css';
    st.textContent = css;
    (doc.head || doc.documentElement).appendChild(st);
  }

  // 2) Respaldo: regresar la cantidad a 1 si quedo mas alta.
  var enVuelo = false;
  function clamp() {
    if (enVuelo) return;
    enVuelo = true;
    global.fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cambios = planClamp(cart && cart.items);
        if (!cambios.length) return null;
        // Un cambio a la vez: /cart/change.js reescribe el carrito completo.
        return cambios.reduce(function (p, c) {
          return p.then(function () {
            return global.fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: c.key, quantity: c.quantity })
            });
          });
        }, global.Promise.resolve()).then(function () {
          // Refrescar el drawer para que muestre la cantidad corregida.
          try {
            if (global.Rebuy && global.Rebuy.SmartCart && global.Rebuy.SmartCart.refresh) global.Rebuy.SmartCart.refresh();
            else doc.dispatchEvent(new global.CustomEvent('rebuy:cart.refresh'));
          } catch (e) {}
        });
      })
      .catch(function () { /* nunca romper el carrito por el respaldo */ })
      .then(function () { global.setTimeout(function () { enVuelo = false; }, 400); });
  }

  function start() {
    injectCss();
    clamp();
    ['rebuy:cart.change', 'rebuy:cart.add', 'rebuy:cart.ready', 'cart:updated']
      .forEach(function (ev) { doc.addEventListener(ev, function () { global.setTimeout(clamp, 250); }, false); });
    // El drawer se puede abrir desde cualquier pagina; re-inyectar si Rebuy
    // reescribe el <head> o si su CSS carga despues.
    global.setInterval(injectCss, 2000);
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start);
  else start();
})(typeof globalThis !== 'undefined' ? globalThis : this);
